// TODO: move this directive to external dop angular library

import { Directive, ElementRef, Renderer2, Input, AfterViewInit, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appInputNumber]'
})
export class InputNumberDirective implements AfterViewInit {
  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  @Input('appInputNumber') number: HTMLInputElement;
  @Output() update = new EventEmitter<number>();

  caretUp: any;
  caretDown: any;

  ngAfterViewInit(): void {
    this.caretUp = this.renderer.createElement('i');
    this.renderer.addClass(this.caretUp, 'ei');
    this.renderer.addClass(this.caretUp, 'ei-caret-up');

    this.renderer.listen(this.caretUp, 'click', this.onArrowUp);

    this.caretDown = this.renderer.createElement('i');
    this.renderer.addClass(this.caretDown, 'ei');
    this.renderer.addClass(this.caretDown, 'ei-caret-down');

    this.renderer.listen(this.caretDown, 'click', this.onArrowDown);

    this.renderer.appendChild(this.elementRef.nativeElement, this.caretUp);
    this.renderer.appendChild(this.elementRef.nativeElement, this.caretDown);
  }

  onArrowUp = () => {
    this.number.value = this.number.value === '' ? '0' : this.number.value;
    if ((parseInt(this.number.value, 10) + 1).toString().length <= this.number.maxLength) {
      this.number.value = (parseInt(this.number.value, 10) + 1).toString();
      this.update.emit(parseInt(this.number.value, 10));
    }
  }

  onArrowDown = () => {
    this.number.value = this.number.value === '' ? '0' : this.number.value;
    if (parseInt(this.number.value, 10) - 1 > 0) {
      this.number.value = (parseInt(this.number.value, 10) - 1).toString();
      this.update.emit(parseInt(this.number.value, 10));
    }
  }
}
